<template>
  <div class="page-wrapper solistic-view-card">
    <div class="container-fluid">
      <div class="page-title">
        <h1>Solistic View Details</h1>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="document-view-body">
            <p><img class="elevate-logo" src="@/assets/images/darknuera.png" alt="NuEra Logo"></p>
            <div class="directory-block">
              <h4 style="font-weight: 600;">{{ data.user_info.first_name }} {{ data.user_info.last_name }}</h4>
              <h6>{{ data.user_info.address1 }}</h6>
              <h6>{{ data.user_info.city }}, {{ data.user_info.state }} {{ data.user_info.zip }}</h6>

            </div>

            <p style="text-align: right">July 29th, 2025</p>

            <p><strong>Dear Valued Member,</strong></p>
            <p>
              As of <strong>July 1st, 2025</strong>, your current Solistic plan will be billed at the updated renewal
              rate,
              which was renewed on <strong>June 1, 2025</strong>. There is nothing you need to do on your end as the
              renewal is automatic. This is just a formal notification of the rate change.
            </p>
            <p>
              Billing will be adjusted accordingly on your upcoming Statement or Electronic Payment (EFT).
            </p>
            <br>
            <p><strong>Your new rate for your Solistic plan as of July 1st, 2025 will be as follows:</strong></p>

            <div v-if="filteredPlanInfo.length" class="new-rate-details">
              <ul>
                <li>Plan: <strong>{{ all_plans }}</strong></li>
                <li v-if="planRate">Plan Rate: <strong>${{ parseFloat(planRate.new_rate).toFixed(2) }}</strong></li>
                <li v-if="assocFee">Association Fee: <strong>${{ parseFloat(assocFee.new_rate).toFixed(2) }}</strong>
                </li>
                <li>Total: <strong>${{ totalRate.toFixed(2) }}</strong></li>
              </ul>
            </div>

            <p class="osf"><em>This new rate will be effective until the next renewal on <strong>June 30,
                  2026.</strong></em></p>
            <p class="osf"><em>If you have any questions, you may contact your representative or broker.</em></p>
            <br>
            <p>
              <span>Broker: <b>{{ data.other_info.agent_name }}</b></span>
              <span style="margin-left: 14%;">Phone: <b>{{ data.other_info.agent_phone }}</b></span>
            </p>
            <br>
            <div class="doc-footer">
              <p><strong>Sincerely,</strong></p>
              <p class="osf">NEB Billing Services</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SolisticViewCard',
  data() {
    return {
      data: {
        user_id: '',
        plan_info: [],
        user_info: {},
        other_info: {},
      },
      loading: false,
      error: null,
      policy_id: null,
    };
  },
  computed: {
    filteredPlanInfo() {
      return this.data.plan_info.filter(item => item.is_assoc === 0 && item.carrier_id === 11);
    },
    all_plans() {
      return this.data.plan_info
        .filter(item => item.is_assoc === 0 && item.carrier_id === 11)
        .map(plan => plan.plan_name)
        .join(', ');
    },
    planRate() {
      return this.data.plan_info.find(
        item => item.is_assoc === 0 && item.carrier_id === 11 && item.pid > 1896
      ) || null;
    },
    assocFee() {
      return this.data.plan_info.find(item => item.is_assoc === 1) || null;
    },
    totalRate() {
      const plan = this.planRate ? parseFloat(this.planRate.new_rate) : 0;
      const fee = this.assocFee ? parseFloat(this.assocFee.new_rate) : 0;
      return plan + fee;
    },
  },
  async created() {
    this.policy_id = atob(this.$route.params.policyId);
    await this.fetchSolisticCardDetails();
  },
  methods: {
    async fetchSolisticCardDetails() {
      this.loading = true;
      this.error = null;
      let loader = this.$loading.show();
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}v2/get-solistic-card-detail/${this.policy_id}`
        );
        this.data = response.data.data;
      } catch (error) {
        this.error = 'Failed to fetch Solistic card details';
        console.error(error);
      } finally {
        this.loading = false;
        loader.hide();
      }
    },
  },
};
</script>

<style scoped>
.document-view-body {
  background: #fff;
  box-shadow: 0 2px 15px rgb(216 227 235 / 33%);
  padding: 30px;
  padding-top: 20px;
  margin-top: 20px;
  border-radius: 15px;
}

.document-view-body p {
  font-size: 14px;
  margin-bottom: 10px;
}

.new-rate-details {
  padding: 30px;
  max-width: 800px;
  margin-bottom: 13px;
  background: #f3f7fa;
  border-radius: 10px;
  margin-top: 15px;
}

.document-view-body .osf {
  opacity: 0.7;
  margin-bottom: 5px;
}

.new-rate-details ul {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
}

.new-rate-details ul li {
  display: inline-block;
}

.new-rate-details strong {
  color: #03c3ec;
}

.doc-footer p {
  margin-bottom: 4px;
}

.doc-footer .osf {
  margin-bottom: 2px;
}

.elevate-logo {
  width: 10%;
  display: block;
  margin: 0px auto;
  margin-top: 2%;
}

.directory-block {
  margin-bottom: 1%;
}
</style>